<template>
  <ConversationMessageRenderless :message="message" :is-streaming="isStreaming" v-slot="{ html, role, isEmpty }">
    <div v-if="role === 'user'" class="tw:flex tw:justify-end">
      <div
        class="tw:max-w-[86%] tw:rounded-lg tw:bg-[var(--tblr-primary-lt)] tw:px-3 tw:py-2 tw:text-sm tw:leading-6 tw:text-gray-900">
        <div class="conversation-message-mk" v-html="html"></div>
      </div>
    </div>

    <LeadAlert v-else :variant="role === 'error' ? 'error' : 'warning'" :title="role === 'error' ? 'Error' : undefined">
      <div v-if="!isEmpty" class="conversation-message-mk" v-html="html"></div>
      <template v-else>{{ role === 'error' ? 'Something went wrong.' : 'No message.' }}</template>
    </LeadAlert>
  </ConversationMessageRenderless>
</template>

<script setup lang="ts">
import { ConversationMessage as ConversationMessageRenderless } from '@llmor/autopilot-vue';
import type { ConversationMessage } from '@llmor/autopilot-core';
import LeadAlert from '@/components/lead-design/LeadAlert.vue';

defineProps<{
  message: ConversationMessage;
  isStreaming?: boolean;
}>();
</script>

<style scoped>
.conversation-message-mk {
  overflow-x: auto;
  overflow-y: visible;
  max-width: 100%;
  word-wrap: break-word;
}

.conversation-message-mk :deep(p) {
  margin-bottom: 0.5rem;
}

.conversation-message-mk :deep(p:last-child) {
  margin-bottom: 0;
}

.conversation-message-mk :deep(pre) {
  background-color: var(--tblr-bg-surface-secondary);
  border: 1px solid var(--tblr-border-color);
  border-radius: var(--tblr-border-radius);
  padding: 0.5rem;
  margin: 0.5rem 0;
  font-size: 0.75rem;
  overflow-x: auto;
}

.conversation-message-mk :deep(code) {
  background-color: var(--tblr-bg-surface-secondary);
  border-radius: var(--tblr-border-radius-sm);
  padding: 0.125rem 0.25rem;
  font-size: 0.75rem;
}
</style>
